(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-menu"] && !Shopify.designMode) return;
  try {
    
  const scSvg = (path) =>
    `<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="${path}" fill="#1C1B1F"></path></svg>`;
  const SC_PLUS = 'M4.26935 5.41371H0V4.26935H4.26935V0H5.41371V4.26935H9.68305V5.41371H5.41371V9.68305H4.26935V5.41371Z';
  const SC_MINUS = 'M0 4.26935H9.68305V5.41371H0Z';

  // FDR: the drawer renders two menu blocks (footer links + main menu), so the
  // accordion must be bound to every [data-sc-drawer-menu], not just the first one.
  document.querySelectorAll('[data-sc-drawer-menu]').forEach((scDrawerMenu) => {
    scDrawerMenu.addEventListener('click', (evt) => {
      const toggle = evt.target.closest('.sc-accordion-toggle');
      if (!toggle) return;

      const item = toggle.closest('li');
      const list = item.querySelector('.sc-submenu-list');
      if (!list) return;

      // Mutually exclusive: close any other open submenu
      scDrawerMenu.querySelectorAll('.sc-submenu-list.open').forEach((openList) => {
        if (openList !== list) {
          openList.classList.remove('open');
          const openPlus = openList.closest('li')?.querySelector('.sc-plus');
          if (openPlus) {
            openPlus.classList.remove('open');
            openPlus.innerHTML = scSvg(SC_PLUS);
          }
        }
      });

      const plus = toggle.querySelector('.sc-plus');
      list.classList.toggle('open');
      plus.classList.toggle('open');
      plus.innerHTML = plus.classList.contains('open') ? scSvg(SC_MINUS) : scSvg(SC_PLUS);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
